module.exports = __webpack_public_path__ + "font2_vivaldi.png?b026e5e3bb84ebc1acccc7cc115424bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/font2_vivaldi.png
// module id = 73
// module chunks = 0